import { TaskListItem } from './task-list-item';
import { OrderReturnItem } from './order-return-item';

export class ReturningTaskListItem extends TaskListItem {
    public orderReturnItemList: OrderReturnItem[];
    public Notes: string;
    public TotalRefundPrice: number;
    public CustomerPhone: number;
}
